import { Row, Col, Spin } from "antd";

const Loading = () => (
  <>
    <Row justify="center" style={{ textAlign: "center", height: "100vh" }} align="middle" >
      <Col span={24}>
        <Spin tip="Loading" size="large" />
      </Col>
    </Row>
  </>
)
export default Loading;
